var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1114_5727",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 14,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5V21H19V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1114_5727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3456 3C15.3147 3.30644 16.9714 6.68295 15.3043 9.25419C13.474 12.0773 9.16083 11.4336 8.20605 8.20236C7.49115 5.78302 9.15217 3.20825 11.6528 3H12.3456Z",
    fill: "#FF9355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5422 12.0101C14.8378 11.7957 17.8606 13.9826 18.7448 17.1949C19.1791 18.7737 19.2718 20.7228 17.2492 21.0002H6.75051C4.72837 20.7228 4.82016 18.7746 5.2549 17.1949C6.04471 14.3247 8.59775 12.2016 11.5422 12.0101Z",
    fill: "#FF9355"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.ba12327b043524e9a44cc06e0c0bec2e.svg";
export { ForwardRef as ReactComponent };